import React from "react";
import { BATTERY_ACTIVITY_TYPES, ACTIVITY_TYPES } from "./constants";

export { BATTERY_ACTIVITY_TYPES, ACTIVITY_TYPES };

const ActivityIcon = ({ type, className = "w-7 h-7 flex-shrink-0" }) => {
  switch (type) {
    case ACTIVITY_TYPES.KEPT_FOR_CHARGING:
      // Yellow circular badge with charging / reload plug icon
      return (
        <svg
          width={24}
          height={24}
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className={className}
        >
          <rect width={24} height={24} rx={12} fill="#eab726" />
          <path
            d="M16.959 10.542c.875 0 .875.291.875.875v1.166c0 .584 0 .875-.875.875m-6.126-3.791-1.102 1.458a.58.58 0 0 0 .501.875h1.342c.45 0 .73.484.508.875l-1.249 1.458m-1.75 1.75c-2.333 0-2.916-.583-2.916-2.916v-2.334c0-2.333.583-2.916 2.916-2.916m3.501 0c2.333 0 2.916.583 2.916 2.916v2.334c0 2.333-.583 2.916-2.916 2.916"
            stroke="#fcfcfc"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );

    case ACTIVITY_TYPES.CHECKED_IN_SOS:
    case ACTIVITY_TYPES.ASSIGNED_SOS:
      // Red circular badge with "SOS" text
      return (
        <svg
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className={className}
        >
          <rect width={24} height={24} rx={12} fill="#c84630" />
          <path
            d="M6.328 9.612q-.408 0-.664.208t-.256.608q0 .392.304.6t.736.304.864.224q.432.12.736.456t.304.952-.52 1.104-1.392.488-1.416-.408-.544-1.128h.976q.032.368.272.584t.704.216.728-.24a.74.74 0 0 0 .272-.568q0-.329-.168-.512a.94.94 0 0 0-.424-.272q-.256-.096-.568-.168a10 10 0 0 1-.632-.168 2.8 2.8 0 0 1-.576-.248 1.2 1.2 0 0 1-.424-.44 1.5 1.5 0 0 1-.16-.72q0-.728.52-1.168.528-.448 1.36-.448.84 0 1.336.384.504.384.56 1.112H7.248a.8.8 0 0 0-.272-.536q-.24-.216-.648-.216m5.636 4.12q.84 0 1.368-.552.536-.56.536-1.464 0-.912-.536-1.464-.528-.552-1.368-.552t-1.376.552q-.528.552-.528 1.464 0 .904.528 1.464.536.552 1.376.552m0 .824q-1.192 0-2.016-.8-.825-.808-.824-2.04 0-1.24.824-2.04.824-.808 2.016-.808 1.2 0 2.016.808.825.8.824 2.04 0 1.231-.824 2.04-.816.8-2.016.8m5.466-4.944q-.408 0-.664.208t-.256.608q-.001.392.304.6.303.208.736.304.432.096.864.224.432.12.736.456.303.336.304.952 0 .616-.52 1.104t-1.392.488q-.873 0-1.416-.408-.544-.408-.544-1.128h.976q.031.368.272.584.24.216.704.216t.728-.24a.74.74 0 0 0 .272-.568q0-.329-.168-.512a.94.94 0 0 0-.424-.272 5 5 0 0 0-.568-.168 10 10 0 0 1-.632-.168 2.8 2.8 0 0 1-.576-.248 1.2 1.2 0 0 1-.424-.44 1.5 1.5 0 0 1-.16-.72q0-.728.52-1.168.528-.448 1.36-.448.84 0 1.336.384.503.384.56 1.112H18.35a.8.8 0 0 0-.272-.536q-.24-.216-.648-.216"
            fill="#fcfcfc"
          />
        </svg>
      );

    case ACTIVITY_TYPES.WITHDRAWN_LOCKER:
      // Green circular badge with arrow pointing up (withdrawal)
      return (
        <svg
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className={className}
        >
          <rect width={24} height={24} rx={12} fill="#169757" />
          <path
            d="M10.25 17.833h3.5c2.916 0 4.083-1.166 4.083-4.083v-3.5c0-2.917-1.166-4.083-4.083-4.083h-3.5c-2.917 0-4.083 1.166-4.083 4.083v3.5c0 2.917 1.166 4.083 4.083 4.083"
            stroke="#fcfcfc"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M10.25 10.548 12 8.798l1.75 1.75M12 8.797v4.667"
            stroke="#fcfcfc"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );

    case ACTIVITY_TYPES.DEPOSITED_LOCKER:
      // Blue circular badge with arrow pointing down (deposit)
      return (
        <svg
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className={className}
        >
          <rect width={24} height={24} rx={12} fill="#135bba" />
          <path
            d="M10.25 6.167h3.5c2.916 0 4.083 1.166 4.083 4.083v3.5c0 2.917-1.166 4.083-4.083 4.083h-3.5c-2.917 0-4.083-1.166-4.083-4.083v-3.5c0-2.917 1.166-4.083 4.083-4.083"
            stroke="#fcfcfc"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="m10.25 13.453 1.75 1.75 1.75-1.75M12 15.203v-4.667"
            stroke="#fcfcfc"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );

    case ACTIVITY_TYPES.ASSIGNED_TRIP:
      // Dark teal circular badge with chain links
      return (
        <svg
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className={className}
        >
          <rect width={24} height={24} rx={12} fill="#085054" />
          <path
            d="M6.207 7.683c.467-2.018 3.506-2.018 3.967 0 .274 1.184-.478 2.188-1.132 2.812-.478.455-1.23.45-1.709 0-.647-.624-1.4-1.628-1.126-2.812Zm7.583 7c.468-2.018 3.524-2.018 3.99 0 .275 1.185-.478 2.188-1.137 2.812a1.254 1.254 0 0 1-1.715 0c-.659-.624-1.411-1.628-1.137-2.812Z"
            stroke="#fcfcfc"
          />
          <path
            d="M12 7.917h1.563c1.08 0 1.581 1.335.77 2.047l-4.66 4.078c-.811.706-.31 2.041.764 2.041H12"
            stroke="#fcfcfc"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );

    case ACTIVITY_TYPES.REMOVED_FROM_TRIP:
      // Red circular badge with broken/unlinked chain
      return (
        <svg
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className={className}
        >
          <rect width={24} height={24} rx={12} fill="#c84630" />
          <path
            d="M6.207 7.683c.467-2.018 3.506-2.018 3.967 0 .274 1.184-.478 2.188-1.132 2.812-.478.455-1.23.45-1.709 0-.647-.624-1.4-1.628-1.126-2.812Zm7.583 7c.468-2.018 3.524-2.018 3.99 0 .275 1.185-.478 2.188-1.137 2.812a1.254 1.254 0 0 1-1.715 0c-.659-.624-1.411-1.628-1.137-2.812Z"
            stroke="#fcfcfc"
          />
          <path
            d="m9 15 6-6"
            stroke="#fcfcfc"
            strokeWidth={1.5}
            strokeLinecap="round"
          />
        </svg>
      );

    case ACTIVITY_TYPES.FULLY_CHARGED:
      // Amber/Gold circular badge with battery full icon
      return (
        <svg
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className={className}
        >
          <rect width={24} height={24} rx={12} fill="#eab726" />
          <path
            d="M16.959 10.542c.875 0 .875.291.875.875v1.166c0 .584 0 .875-.875.875m-4.376 2.625h-3.5c-2.333 0-2.916-.583-2.916-2.916v-2.334c0-2.333.583-2.916 2.916-2.916h3.5c2.333 0 2.917.583 2.917 2.916v2.334c0 2.333-.584 2.916-2.917 2.916"
            stroke="#fcfcfc"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M8.722 10.833a4.8 4.8 0 0 1 0 2.334"
            stroke="#fcfcfc"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M10.763 10.833c.193.765.193 1.57 0 2.334m2.042-2.334c.193.765.193 1.57 0 2.334"
            stroke="#fcfcfc"
            strokeWidth={1.5}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );

    case ACTIVITY_TYPES.CHECKED_IN:
      // Orange circular badge with check-in arrow
      return (
        <svg
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className={className}
        >
          <rect width={24} height={24} rx={12} fill="#f18725" />
          <path
            d="M12 17.833a5.833 5.833 0 1 0 0-11.666 5.833 5.833 0 0 0 0 11.666M14.042 12h-3.5"
            stroke="#fcfcfc"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M11.709 10.25 9.959 12l1.75 1.75"
            stroke="#fcfcfc"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );

    case ACTIVITY_TYPES.CHECKED_OUT:
      // Cyan / Light blue circular badge with check-out arrow
      return (
        <svg
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className={className}
        >
          <rect width={24} height={24} rx={12} fill="#0892bd" />
          <path
            d="M12 17.833a5.833 5.833 0 1 0 0-11.666 5.833 5.833 0 0 0 0 11.666M9.959 12h3.5"
            stroke="#fcfcfc"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="m12.292 13.75 1.75-1.75-1.75-1.75"
            stroke="#fcfcfc"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );

    case ACTIVITY_TYPES.ASSIGNED_SWAP:
      // Magenta / Pink circular badge with circular swap arrows
      return (
        <svg
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className={className}
        >
          <rect width={24} height={24} rx={12} fill="#df367c" />
          <path
            d="M17.833 12A5.835 5.835 0 0 1 12 17.833c-3.22 0-5.186-3.243-5.186-3.243m0 2.917V14.59h2.637M6.166 12A5.82 5.82 0 0 1 12 6.167c3.89 0 5.833 3.243 5.833 3.243m-2.59 0h2.59V6.493"
            stroke="#fcfcfc"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );

    case ACTIVITY_TYPES.ASSIGNED_RENTAL:
    case ACTIVITY_TYPES.ASSOCIATED_RENTAL:
      // Purple circular badge with rental / ticket badge
      return (
        <svg
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className={className}
        >
          <rect width={24} height={24} rx={12} fill="#775dfa" />
          <path
            d="m16.958 13.744-2.922 2.928m-6.994-2.928h9.916m-9.916-3.488 2.922-2.928m6.994 2.928H7.042"
            stroke="#fcfcfc"
            strokeMiterlimit={10}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );

    case ACTIVITY_TYPES.ASSIGNED_TRANSFER:
      // Charcoal / Black circular badge with transit/transfer icon
      return (
        <svg
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className={className}
        >
          <rect width={24} height={24} rx={12} fill="#000" />
          <path
            d="m10.262 6.657-3.145 2.45c-.525.408-.95 1.277-.95 1.936v4.323a2.465 2.465 0 0 0 2.455 2.462h6.755a2.464 2.464 0 0 0 2.456-2.456v-4.247c0-.706-.472-1.61-1.05-2.012l-3.605-2.526c-.817-.572-2.129-.543-2.917.07m.867 3.01h1.75M9.667 13.75h4.667M9.667 15.5h4.667"
            stroke="#fcfcfc"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M9.667 17.833v-5.125a1 1 0 0 1 1-1h2.666a1 1 0 0 1 1 1v5.125"
            stroke="#fcfcfc"
          />
        </svg>
      );

    case ACTIVITY_TYPES.ASSIGNED_SESSION:
    case ACTIVITY_TYPES.ASSOCIATED_SESSION:
      // Brown circular badge with AgriTech / session icon
      return (
        <svg
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className={className}
        >
          <rect width={24} height={24} rx={12} fill="#a25712" />
          <path
            d="M7.91 6.167a3.424 3.424 0 0 1 3.424 3.424v7.659a3.424 3.424 0 0 1-3.424-3.424zm4.173 6.046a3.424 3.424 0 0 1 3.424 3.424v1.613h-3.424zm-.104-2.185a1.728 1.728 0 1 1 3.455 0 1.728 1.728 0 0 1-3.455 0"
            fill="#fcfcfc"
          />
        </svg>
      );

    case ACTIVITY_TYPES.REMOVED_FROM_SESSION:
      // Red circular badge with AgriTech / session icon and disconnect slash
      return (
        <svg
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className={className}
        >
          <rect width={24} height={24} rx={12} fill="#c84630" />
          <path
            d="M7.91 6.167a3.424 3.424 0 0 1 3.424 3.424v7.659a3.424 3.424 0 0 1-3.424-3.424zm4.173 6.046a3.424 3.424 0 0 1 3.424 3.424v1.613h-3.424zm-.104-2.185a1.728 1.728 0 1 1 3.455 0 1.728 1.728 0 0 1-3.455 0"
            fill="#fcfcfc"
          />
          <path
            d="m7 17 10-10"
            stroke="#fcfcfc"
            strokeWidth={1.5}
            strokeLinecap="round"
          />
        </svg>
      );

    case ACTIVITY_TYPES.ADDED_TO_SERVICE:
      // Slate Grey circular badge with wrench icon
      return (
        <svg
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className={className}
        >
          <rect width={24} height={24} rx={12} fill="#525252" />
          <g clipPath="url(#a)">
            <path
              d="M12.586 11.754a.7.7 0 0 0-.112-.15l-.501-.494a.6.6 0 0 0-.18-.125m.793.769a.595.595 0 0 1-.105.689c-.177.174-.49.489-1.047 1.037-1.086 1.073-2.92 3.114-3.719 4.053a.44.44 0 0 1-.647.025L6 16.48a.44.44 0 0 1 .03-.644c.922-.777 2.961-2.597 4.06-3.684.574-.567.892-.88 1.066-1.05a.57.57 0 0 1 .636-.117m.793.769c.38-.37 1.375-1.19 1.64-1.354.267-.164.481-.21.584-.222a1 1 0 0 1 .583.127.4.4 0 0 1 .084.065.46.46 0 0 1-.014.649l-.054.052a.15.15 0 0 0 0 .214l.938.93a.15.15 0 0 0 .11.043c.04 0 .08-.015.109-.043l1.516-1.5a.16.16 0 0 0 0-.219l-.938-.93a.15.15 0 0 0-.11-.043.15.15 0 0 0-.109.043.31.31 0 0 1-.26.09.58.58 0 0 1-.338-.133c-.191-.188.03-.557-.139-.793a7 7 0 0 0-.63-.73c-.194-.192-.953-.916-2.23-1.437a3.4 3.4 0 0 0-1.286-.253c-.72 0-1.274.322-1.476.506-.161.146-.328.377-.328.377q.145-.052.295-.088.316-.067.637-.04c.425.035.938.235 1.213.45.443.356.634.832.664 1.445.021.457-.838 1.555-1.254 2.025"
              stroke="#fcfcfc"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
          <defs>
            <clipPath id="a">
              <path fill="#fff" d="M5 5h14v14H5z" />
            </clipPath>
          </defs>
        </svg>
      );

    case ACTIVITY_TYPES.SERVICE_COMPLETED:
      // Dark Teal circular badge with wrench icon
      return (
        <svg
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className={className}
        >
          <rect width={24} height={24} rx={12} fill="#085054" />
          <g clipPath="url(#a)">
            <path
              d="M12.586 11.754a.7.7 0 0 0-.112-.15l-.501-.494a.6.6 0 0 0-.18-.125m.793.769a.595.595 0 0 1-.105.689c-.177.174-.49.489-1.047 1.037-1.086 1.073-2.92 3.114-3.719 4.053a.44.44 0 0 1-.647.025L6 16.48a.44.44 0 0 1 .03-.644c.922-.777 2.961-2.597 4.06-3.684.574-.567.892-.88 1.066-1.05a.57.57 0 0 1 .636-.117m.793.769c.38-.37 1.375-1.19 1.64-1.354.267-.164.481-.21.584-.222a1 1 0 0 1 .583.127.4.4 0 0 1 .084.065.46.46 0 0 1-.014.649l-.054.052a.15.15 0 0 0 0 .214l.938.93a.15.15 0 0 0 .11.043c.04 0 .08-.015.109-.043l1.516-1.5a.16.16 0 0 0 0-.219l-.938-.93a.15.15 0 0 0-.11-.043.15.15 0 0 0-.109.043.31.31 0 0 1-.26.09.58.58 0 0 1-.338-.133c-.191-.188.03-.557-.139-.793a7 7 0 0 0-.63-.73c-.194-.192-.953-.916-2.23-1.437a3.4 3.4 0 0 0-1.286-.253c-.72 0-1.274.322-1.476.506-.161.146-.328.377-.328.377q.145-.052.295-.088.316-.067.637-.04c.425.035.938.235 1.213.45.443.356.634.832.664 1.445.021.457-.838 1.555-1.254 2.025"
              stroke="#fcfcfc"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
          <defs>
            <clipPath id="a">
              <path fill="#fff" d="M5 5h14v14H5z" />
            </clipPath>
          </defs>
        </svg>
      );

    default:
      return (
        <svg
          viewBox="0 0 28 28"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className={className}
        >
          <circle cx="14" cy="14" r="14" fill="#ADADB0" />
          <circle cx="14" cy="14" r="3" fill="white" />
        </svg>
      );
  }
};

export default ActivityIcon;
